import React, { useEffect } from 'react'
import { Dimensions, Image, StyleSheet, View } from 'react-native'
import Layout from '../../constants/Layout'
import { CustomChip } from '../../components/chips/Chip'
import IconNames from '../../constants/IconNames'
import PageTitle from '../../components/tags/PageTitle'
import { useRoute } from '@react-navigation/native'
import { useNavigation } from '@react-navigation/core'
import { CustomText } from '../../components/text/StyledText'
import MainContainer from '../../components/MainContainer/MainContainer'
import MySessions from '../../components/views/snakSammen/volunteer/MySessions'
import PreviousSessions from '../../components/views/snakSammen/volunteer/PreviousSessions'
import Materials from '../../components/views/snakSammen/volunteer/Materials'
import { txt } from '../../locales/i18n'
import { getVolunteerAccess } from '../../services/api/volunteerApi'
import Colors from "../../constants/Colors"

const { width } = Dimensions.get('window')

export default function VolunteerScreen() {
  const route = useRoute()
  const navigation = useNavigation()

  let chip = route.params?.chip

  const mine = txt('learnDanish.volunteer.chipMine')
  const previous = txt('learnDanish.volunteer.chipPrevious')
  const materials = txt('learnDanish.volunteer.chipMaterials')
  const test = txt('learnDanish.volunteer.chipTest')

  useEffect(() => {
    navigation.setOptions({
      headerBackTitle: ' ',
      headerStyle: { 
        backgroundColor: Colors.background,
        borderBottomColor: 'transparent',
        elevation: 0, // remove shadow on Android
        shadowOpacity: 0,
        height: 120
      },
      headerTitle: () => (
        <Image
          style={styles.logo}
          resizeMode="contain"
          source={{ uri: 'https://filer.boblberg.dk/assets/img/snaksammen/snaksammen-logo.png' }}
          accessibilityLabel={'SnakSammen'}
          accessibilityIgnoresInvertColors
        />
      ),
    })

    getVolunteerAccess('snaksammen').then((volunteer) => {
      if (!volunteer.isVolunteer) navigation.navigate('SnakSammen')
    })

    let chip = route.params?.chip

    if (Number(chip)) {
      navigation.navigate('SnakSammenVolunteer', {
        id: chip,
      })
    } else if (!chip) {
      chip = mine
      setChipParam(chip)
    }
  }, [])

  const setChipParam = (chip) => navigation.setParams({ chip })

  function renderChips() {
    return (
      <View style={styles.chipContainer}>
        {/* Create + own bookings */}
        <View style={styles.chip}>
          <CustomChip
            icon={IconNames.clock}
            iconStroke={'fal'}
            selected={route.params?.chip === mine}
            onPress={() => setChipParam(mine)}
            accessibilityLabel={txt('learnDanish.volunteer.mine')}
            text={mine.charAt(0).toUpperCase() + mine.slice(1)}
          />
        </View>

        {/* Previous bookings */}
        <View style={styles.chip}>
          <CustomChip
            icon={IconNames.history}
            iconStroke={'fal'}
            selected={route.params?.chip === previous}
            onPress={() => setChipParam(previous)}
            accessibilityLabel={txt('learnDanish.volunteer.previous')}
            text={previous.charAt(0).toUpperCase() + previous.slice(1)}
          />
        </View>

        {/* Materials */}
        <View style={styles.chip}>
          <CustomChip
            icon={IconNames.paperclip}
            iconStroke={'fal'}
            selected={route.params?.chip === materials}
            onPress={() => setChipParam(materials)}
            accessibilityLabel={txt('learnDanish.volunteer.materials.title')}
            text={width > 350 && materials.charAt(0).toUpperCase() + materials.slice(1)}
          />
        </View>
      </View>
    )
  }

  switch (chip) {
    case previous:
      return (
        <MainContainer>
          <PageTitle title={txt('learnDanish.volunteer.previous')} />
          {renderChips()}
          <PreviousSessions />
        </MainContainer>
      )
    case materials:
      return (
        <MainContainer>
          <PageTitle title={txt('learnDanish.volunteer.materials.title')} />
          {renderChips()}
          <Materials />
        </MainContainer>
      )
    case test:
      return (
        <MainContainer>
          <PageTitle title={txt('learnDanish.volunteer.test')} />
          {renderChips()}
          <View style={styles.container}>
            <CustomText>Test</CustomText>
          </View>
        </MainContainer>
      )
    case mine:
    default:
      return (
        <MainContainer>
          <PageTitle title={txt('learnDanish.volunteer.mine')} />
          {renderChips()}
          <MySessions />
        </MainContainer>
      )
  }
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: Layout.maxFeedWidth,
    alignSelf: 'center',
  },
  chip: {
    marginBottom: 10,
    marginLeft: 5,
    marginRight: 5,
  },
  chipContainer: {
    alignSelf: 'center',
    flexDirection: 'row',
  },
  logo: {
    width: 200,
    height: Layout.isSmallDevice ? 60 : 70  
  }
})
